import React from 'react';
import classnames from 'classnames';
import PrintHelper from 'print-helper-lib';

import { TabGroup } from 'web-ui-components/lib/navigation/tab-group';
import PropTypes from 'prop-types';
import ActivePaymentListing from '../ManagePaymentListing/ActivePaymentListing';
import ManagePaymentFilterOptions from '../ManagePaymentFilterOptions/ManagePaymentFilterOptions';
import ArchivedPaymentListing from '../ManagePaymentListing/ArchivedPaymentListing';
import { parseString } from '../../../helpers/contentParser';
import { managePaymentTabOptions, ACTIVE_TAB } from '../../../config';
import { contentPropTypes } from '../../content/ManagePayment.content';
import accountPropType from '../../../states/accounts/propTypes';
import { GenericPaginator } from 'web-ui-components/lib/data/filter-and-search';
import { styles } from './ManagePaymentDetailStyles';

const ManagePaymentDetail = ({
	activeTab,
	handleActiveTabChange,
	mandateActiveFilter,
	handleManagePaymentFilterChange,
	hasApiCallInProgress,
	hasError,
	handleView,
	renderRetryComponent,
	handleEdit,
	handleCancelView,
	handleEditById,
	accounts,
	hasIFTPayment,
	content,
	mandateTotals,
	mandateActivePage,
	mandateArchivePage,
	handlePageChange,
	persistSortOrder,
}) => {
	const showActivePaymentListing = activeTab === ACTIVE_TAB;
	const { mandateActivePageTotal, mandateArchivePageTotal } = mandateTotals;
	const page = showActivePaymentListing ? mandateActivePage : mandateArchivePage;
	const pageTotal = showActivePaymentListing ? mandateActivePageTotal : mandateArchivePageTotal;

	const showActivePaginator = showActivePaymentListing && mandateActivePageTotal > 1;
	const showArchivedPaginator = !showActivePaymentListing && mandateArchivePageTotal > 1;
	const showPaginator =
		(showActivePaymentListing && showActivePaginator) || (!showActivePaymentListing && showArchivedPaginator);

	const managePaymentTabs = [
		{
			...managePaymentTabOptions[0],
			title: managePaymentTabOptions[0].title,
		},
		{
			...managePaymentTabOptions[1],
			title: managePaymentTabOptions[1].title,
		},
	];

	const paginator = () => (
		<div data-test-id="scheduled-payment-paging-control" className={classnames(styles.paginator, 'noprint')}>
			<GenericPaginator
				currentPage={page}
				numberOfPages={pageTotal}
				className="u-margin-right-0"
				onChangePage={handlePageChange}
			/>
		</div>
	);

	return (
		<div>
			<PrintHelper className="web-ui-components" brandId="VM" showPrintTopIcon showPrintBottomIcon>
				<div className="u-padding-bottom-4">
					<TabGroup activeTab={activeTab} onChange={handleActiveTabChange} tabButtons={managePaymentTabs} />
				</div>

				{showActivePaymentListing && (
					<div className="u-padding-bottom-4">
						<ManagePaymentFilterOptions
							selectedFilter={mandateActiveFilter}
							handleManagePaymentFilterChange={handleManagePaymentFilterChange}
						/>
					</div>
				)}

				{showPaginator && paginator()}

				{showActivePaymentListing && (
					<ActivePaymentListing
						hasApiCallInProgress={hasApiCallInProgress}
						hasError={hasError}
						selectedFilter={mandateActiveFilter}
						handleView={handleView}
						renderRetryComponent={renderRetryComponent}
						handleEdit={handleEdit}
						handleCancelView={handleCancelView}
						handleEditById={handleEditById}
						accounts={accounts}
						mandateActivePage={mandateActivePage}
						mandateActivePageTotal={mandateActivePageTotal}
						persistSortOrder={persistSortOrder}
					/>
				)}
				{!showActivePaymentListing && (
					<ArchivedPaymentListing
						hasApiCallInProgress={hasApiCallInProgress}
						hasError={hasError}
						renderRetryComponent={renderRetryComponent}
						handleView={handleView}
						mandateArchivePage={mandateArchivePage}
						mandateArchivePageTotal={mandateArchivePageTotal}
						persistSortOrder={persistSortOrder}
					/>
				)}
				{hasIFTPayment && (
					<div>
						<p>{parseString(content.importantInfoHeader)}</p>
						<p>{parseString(content.importantInfoText)}</p>
					</div>
				)}

				<div className="u-margin-top-2">{showPaginator && paginator()}</div>
			</PrintHelper>
		</div>
	);
};

ManagePaymentDetail.propTypes = {
	activeTab: PropTypes.string.isRequired,
	handleActiveTabChange: PropTypes.func.isRequired,
	mandateActiveFilter: PropTypes.string.isRequired,
	handleManagePaymentFilterChange: PropTypes.func.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	hasError: PropTypes.bool.isRequired,
	handleView: PropTypes.func.isRequired,
	renderRetryComponent: PropTypes.func.isRequired,
	handleEdit: PropTypes.func.isRequired,
	handleCancelView: PropTypes.func.isRequired,
	handleEditById: PropTypes.func.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropType)).isRequired,
	hasIFTPayment: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes),
	mandateActivePage: PropTypes.number.isRequired,
	mandateArchivePage: PropTypes.number.isRequired,
	mandateTotals: PropTypes.shape({
		mandateActivePageTotal: PropTypes.number.isRequired,
		mandateArchivePageTotal: PropTypes.number.isRequired,
	}),
	handlePageChange: PropTypes.func.isRequired,
	persistSortOrder: PropTypes.func.isRequired,
};

export default ManagePaymentDetail;
